import React, { PropsWithChildren } from 'react';

import { Button, Modal } from '@/shared/ui';

import './SearchFormModal.scss';

interface SearchFormModalProps {
  handleModalClose: () => void;
  photos?: string[];
  open: boolean;
}

export const SearchFormModal: React.FC<PropsWithChildren<SearchFormModalProps>> = React.memo(
  ({ open, children, handleModalClose }) => {
    return (
      <Modal
        size="lg"
        open={open}
        onCancel={handleModalClose}
        title="Опис"
        closable
        footer={
          <Button onClick={handleModalClose} aria-label="Close modal">
            Закрити
          </Button>
        }
        classNames={{
          content: 'search-form__modal-content',
          body: 'search-form__modal-body',
          footer: 'search-form__modal-footer',
          header: 'search-form__modal-header',
        }}
      >
        {children}
      </Modal>
    );
  },
);
